<template>
    <div id="app">
        <!-- <div v-if="go_new" class="go-new">
            <p>地址更新，<span>{{num}}</span>秒后跳转到新地址...</p>
        </div> -->
        <router-view></router-view>

        <serviceFee :isShow="serviceFee_isShow" :data="total_money_serviceFee"></serviceFee>
        <newNotice :isShow="newNotice_isShow"></newNotice>
        <privateno :isShow="privateno_isShow" :data="total_money_privateno"></privateno>
        <annualFee :isShow="annualFee_isShow" :data="total_money_annualFee"></annualFee>
        <msg :isShow="msg_isShow" :data="total_money_msg" @child-data="handleChildData"></msg>
        <!-- 充值二维码组件 -->
        <rechargeConfig
            :isShow="rechargeConfig_isShow"
            type="0"
        ></rechargeConfig>
    </div>
</template>

<script>
import axios from 'axios'; // AJAX封装类
import { config } from './utils/config'; //配置
import bus from './components/common/bus.js';
import serviceFee from './components/common/serviceFee.vue';
import newNotice from './components/common/newNotice.vue';
import privateno from './components/common/privateno.vue';
import msg from './components/common/msg.vue';
import annualFee from './components/common/annualFee.vue';
import vHead from './components/common/Header';
import vSidebar from './components/common/Sidebar';
import vTags from './components/common/Tags'; // AJAX封装类
import rechargeConfig from './components/common/rechargeConfig.vue';
var _this;
export default {
    components: {
        serviceFee,
        newNotice,
        privateno,
        msg,
        annualFee,
        rechargeConfig
    },

    data() {
        return {
            serviceFee_isShow: false,
            newNotice_isShow: false,
            privateno_isShow: false,
            annualFee_isShow: false,
            msg_isShow:false,
            total_money_annualFee: '',
            total_money_msg:'',

            total_money_serviceFee: '',
            total_money_privateno: '',
            search_data_notify: {
                page: 1,
                limit: 5
            },
            rechargeConfig_isShow: false,
        };
    },

    created() {
        _this = this;

        // axios.defaults.baseURL = config.axios_normalURL;
        // // 高德语音播报token
        // _this
        //     .$post('/system/getBaiduOpenToken')
        //     .then((res) => {
        //         localStorage.setItem('bdToken', res.data.access_token);
        //     })
        //     .catch((err) => {});
        // axios.defaults.baseURL = config.axios_baseURL; //请求base url

        // 获取当前地址
        // var oldHref = window.location.href;
        // console.log(oldHref.slice(14, 16));

        // // 判断当前地址是否为新地址
        // if (oldHref.slice(14, 16) != 'v3') {
        //     this.$message({
        //         showClose: true,
        //         message: '后台管理系统新地址:https://admin.v3.jiuzhoudaijiaapi.cn/',
        //         duration: 0
        //     });
        // }

        // axios.defaults.baseURL = config.axios_normalURL; //请求normal url
        _this
            .$post('/system/systemTimestamp',{},{},'normal')
            .then((res) => {
                // axios.defaults.baseURL = config.axios_baseURL; //请求base url

                let time_difference = res.data.timestamp - Math.round(new Date() / 1000);

                sessionStorage.setItem('time_difference', time_difference);
            })
            .catch((err) => {});

        // axios.defaults.baseURL = config.axios_baseURL; //请求base url

        bus.$on('logIn', (msg) => {
            console.log('触发了app-logIn');

            // 登录后判断是否弹出服务费提醒弹窗
            _this
                .$post('/service_fee/getServiceChargeRemind')
                .then((res) => {
                    if (res.data.is_true == 1) {
                        _this.total_money_serviceFee = res.data.total_money;
                        _this.serviceFee_isShow = !_this.serviceFee_isShow;
                    }
                })
                .catch((err) => {});

            // 根据更新通知是否有新消息来判断是否弹出消息通知弹窗

            _this
                .$post('/notice/adminNoticeLists', _this.search_data_notify)
                .then((res) => {
                    for (let i = 0; i < res.data.length; i++) {
                        if (res.data[0].status == '0') {
                            _this.newNotice_isShow = !_this.newNotice_isShow;
                        }
                    }
                })
                .catch((err) => {});

            // 隐私通话预警通知弹窗

            // _this
            //     .$post('/privateno/getPrivateServiceFeeRemind')
            //     .then((res) => {
            //         if (res.data.is_true == 1) {
            //             _this.total_money_privateno = res.data.total_money;
            //             _this.privateno_isShow = !_this.privateno_isShow;
            //         }
            //     })
            //     .catch((err) => {});



            // 短信条数预警通知弹窗

            _this
                .$post('/msg/getAlertRemind')
                .then((res) => {
                    if (res.data.is_true == 1) {
                        _this.total_money_msg = res.data.total_money;
                        _this.msg_isShow = !_this.msg_isShow;
                    }
                })
                .catch((err) => {});


            // 年费预警通知弹窗

            _this
                .$post('/service_fee/getAnnualFeeRemind')
                .then((res) => {
                    if (res.data.is_true == 1) {
                        _this.total_money_annualFee = res.data.total_money;
                        _this.annualFee_isShow = !_this.privateno_isShow;
                    }
                })
                .catch((err) => {});
        });
    },
    methods: {
        // 处理子组件数据
        handleChildData() {
            console.log('子组件数据:');
            // 可以根据需要进行处理
            this.rechargeConfig_isShow = true;
        }
    },
};
</script>



<style>
@import './assets/css/main.css';
@import './assets/css/color-dark.css';

.go-new {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%);
    padding: 10px;
    background-color: #ccc;
    border-radius: 10px;
}
.baidu {
    display: none !important;
}
</style>
